import React from 'react';

import { Box, Typography } from '@material-ui/core';
import FavoriteIcon from '@material-ui/icons/Favorite';
import { FormattedMessage } from 'react-intl';

const Empty = () => {
  return (
    <Box
      flex={1}
      textAlign="center"
      alignItems="center"
      justifyContent="center"
      display="flex"
      flexDirection="column"
      height="100%"
    >
      <Box color="grey.300">
        <FavoriteIcon fontSize="large" color="inherit" />
      </Box>
      <Box my={2}>
        <Typography variant="h5" component="h1">
          <FormattedMessage id="favorites.empty.title" />
        </Typography>
      </Box>
      <Typography variant="body1" color="textSecondary">
        <FormattedMessage id="favorites.empty.body" />
      </Typography>
    </Box>
  );
};

export default Empty;
